// HOOKS
import { useMutation } from "@apollo/client";

// GRAPHQL
import { DELETE_MANY_PERMISSIONS } from "../../../graphql/mutations/users/permissions.users.mutation";

const useDeleteManyPermissions = () => {
  const [deleteManyPermissionsMutation, { loading, error }] = useMutation(
    DELETE_MANY_PERMISSIONS
  );

  const deleteManyPermissions = async (permissions) => {
    try {
      const response = await deleteManyPermissionsMutation({
        variables: { permissions },
      });
      return response.data.deleteManyPermissions;
    } catch (error) {
      console.error({ error });
      return error;
    }
  };

  return { deleteManyPermissions, loading, error };
};

export default useDeleteManyPermissions;
